/** `14:32` — a hora como o país a escreve. */
export function hourMinute(date: Date): string {
  return date.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
}

/**
 * Quantos dias inteiros se passaram: 0 é hoje, 1 é ontem.
 *
 * A conta é entre meias-noites, e não entre instantes, porque é assim que as
 * pessoas contam: 23h50 de ontem e 00h10 de hoje são "ontem" e "hoje", ainda
 * que separados por vinte minutos.
 */
export function daysSince(iso: string): number {
  const midnight = new Date();
  midnight.setHours(0, 0, 0, 0);

  return Math.floor((midnight.getTime() - new Date(iso).setHours(0, 0, 0, 0)) / 86_400_000);
}

/** `2026-08-16` — a chave de dia usada pelo calendário e pela URL. */
export function dayKey(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** `2026-08-16` → `16/08/2026`. */
export function brDate(key: string): string {
  return key ? key.split('-').reverse().join('/') : '';
}

/**
 * Junta a chave de dia com um `HH:MM` e devolve o instante local.
 *
 * Local, e não UTC: quem escolhe "16/08 às 08:00" quer as oito da manhã aqui.
 * `new Date('2026-08-16T08:00')` já faz isso, mas o construtor por partes deixa
 * explícito que a conversão para UTC é do `toISOString()` depois — que é o que
 * o servidor recebe.
 */
export function instantOf(key: string, time: string): Date {
  const [year, month, day] = key.split('-').map(Number);
  const [hour, minute] = (time || '00:00').split(':').map(Number);

  return new Date(year, month - 1, day, hour, minute, 0, 0);
}
